/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type api_v2_analytics_reports_ReportRowsExport = {
    file_type: api_v2_analytics_reports_ReportRowsExport.file_type;
    row_ids: string;
};
export namespace api_v2_analytics_reports_ReportRowsExport {
    export enum file_type {
        CSV = 'csv',
        XLSX = 'xlsx',
    }
}

